"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.foundation_colors = void 0;
const global_1 = __importDefault(require("./global"));
const icarros_1 = __importDefault(require("./icarros"));
exports.foundation_colors = {
    ...global_1.default,
    ...icarros_1.default,
};
//# sourceMappingURL=index.js.map